import axios from 'axios'

const HU = 'HU'
const GB = 'GB'

export default {
    computed: {
        location() {
            return this.$store.getters['site/siteLocation']
        },
        isHu() {
            return this.location === HU
        },
        isGB() {
            return this.location === GB
        },
    },
    methods: {
        async validateZip(zipCode) {
            if (!zipCode) throw 'No postcode query submitted.'
            try {
                return await axios.get(`https://postcodes.io/postcodes/${zipCode}`)
            } catch (e) {
                throw 'ZIP_NOT_FOUND'
            }
        },
        //addressParams: {latlng: `latitude,longitude`}
        async getAddress(addressParams) {
            try {
                const params = {
                    key: process.env.VUE_APP_GOOGLE_API_KEY,
                    //language: this.currentLanguage,
                    //region: !addressParams.place_id ? this.currentCountry : undefined,
                }
                const queryParams = Object.assign(params, addressParams)
                const response = await axios.get(
                    'https://maps.googleapis.com/maps/api/geocode/json',
                    {
                        params: queryParams,
                        transformRequest: [
                            (data, headers) => {
                                delete headers.common.Authorization
                                return data
                            },
                        ],
                    }
                )
                if (response?.data?.results) return Promise.resolve(response.data.results[0])
                else return Promise.reject()
            } catch (e) {
                return Promise.reject(e)
            }
        },

        getAddressComponents(addressParams) {
            addressParams = JSON.parse(JSON.stringify(addressParams))
            const addressComponents = {
                countryCode: 'country',
                town: 'locality',
                zip_code: 'postalCode',
                street: 'route',
            }
            if (addressParams.house_number && addressParams.street)
                addressParams.street = `${addressParams.street} ${addressParams.house_number}`
            return Object.entries(addressParams).reduce((p, [key, value]) => {
                if (addressComponents[key] && value) p[addressComponents[key]] = value.toString()
                return p
            }, {})
        },

        getCoordinates(latitude, longitude) {
            return { latlng: `${latitude},${longitude}` }
        },

        getAddressText(address) {
            return this.isHu
                ? `${address.zip_code ? ` ${address.zip_code}` : ''}` +
                      `${address.zip_code && !address.town ? `,` : ''}` +
                      `${address.town ? ` ${address.town},` : ''}` +
                      `${address.street ? ` ${address.street}` : ''}` +
                      `${address.street && !address.house_number ? `,` : ''}` +
                      `${address.house_number ? ` ${address.house_number}` : ''}`
                : `${address.house_number ? `${address.house_number}` : ''}` +
                      `${address.house_number && !address.street ? `,` : ''}` +
                      `${address.street ? ` ${address.street},` : ''}` +
                      `${address.town ? ` ${address.town}` : ''}` +
                      `${address.town && !address.zip_code ? `,` : ''}` +
                      `${address.zip_code ? ` ${address.zip_code},` : ''}` +
                      `${address.country_code ? ` ${address.country_code}` : ''}`
        },

        async getConvertedAddress(latitude, longitude) {
            if (!latitude || !longitude) return Promise.reject('No coordinates!')
            try {
                let result = await this.getAddress(this.getCoordinates(latitude, longitude))
                result = this.convertAddress(this.parseAddress(result, false))
                return Promise.resolve(result)
            } catch (e) {
                return Promise.reject(e)
            }
        },

        convertAddress(address) {
            if (!address) return
            const convertedAddress = {
                place_id: address.place_id,
                country: address.country,
                longitude: address.longitude,
                latitude: address.latitude,
                original_longitude: address.longitude,
                original_latitude: address.latitude,
                town: address.locality || address.postal_town,
                zip_code: address.postal_code,
                street: address.route,
                house_number: address.street_number,
                country_code: address.political,
                premise: address.premise,
            }
            return {
                ...convertedAddress,
                ...{
                    full_address: this.getAddressText(convertedAddress),
                },
            }
        },

        parseAddress(addressObj, isMap = true) {
            if (!addressObj) return
            const addressComponents = {
                street_number: 'short_name',
                route: 'long_name',
                locality: 'long_name',
                administrative_area_level_1: 'short_name',
                country: 'long_name',
                // political: 'short_name',
                postal_code: 'short_name',
                postal_town: 'short_name',
                premise: 'short_name',
            }
            const data = {}
            data.place_id = addressObj.place_id
            addressObj.address_components?.forEach((el) => {
                el.types.forEach((type) => {
                    if (addressComponents[type]) {
                        data[type] = el[addressComponents[type]]
                    }
                })
            })
            data.political = this.isGB ? 'UK' : 'HU'
            if (addressObj.geometry) {
                if (isMap) {
                    data.latitude = addressObj.geometry.location.lat()
                    data.longitude = addressObj.geometry.location.lng()
                } else {
                    data.latitude = addressObj.geometry.location.lat
                    data.longitude = addressObj.geometry.location.lng
                }
            }
            if (addressObj.formatted_address) data.formatted_address = addressObj.formatted_address
            return data
        },
    },
}
